import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as n } from "../../../../components/TextSkeleton/index.js";
import { ContainerSkeleton as r, ImageSkeleton as i, Content as S, HeaderSkeleton as d, TimeStampSkeleton as k, TitleSkeletonContainer as h, BottomContainer as m, DealAuthorSkeletonContainer as c, DealActionsRightSkeleton as a, SaveDealButonSkeleton as p, DealCardButtonSkeleton as C } from "./style.js";
import { ActionsSkeleton as s } from "../DealSavedCard/style.js";
import { DealVoteButtonSkeleton as D, DealCommentButtonSkeleton as f } from "../../DealVoteButton/style.js";
const T = ({
  animate: o,
  className: l
}) => /* @__PURE__ */ t(r, { animate: o, className: l, children: [
  /* @__PURE__ */ e(i, {}),
  /* @__PURE__ */ t(S, { children: [
    /* @__PURE__ */ t(d, { children: [
      /* @__PURE__ */ e(D, { animate: o }),
      /* @__PURE__ */ e(k, {})
    ] }),
    /* @__PURE__ */ t(h, { children: [
      /* @__PURE__ */ e(n, { width: "65%" }),
      /* @__PURE__ */ e(n, { width: "50%" })
    ] })
  ] }),
  /* @__PURE__ */ e(s, { children: /* @__PURE__ */ t(m, { children: [
    /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e(n, { width: "102px" }) }),
    /* @__PURE__ */ t(a, { children: [
      /* @__PURE__ */ e(p, {}),
      /* @__PURE__ */ e(f, { animate: o }),
      /* @__PURE__ */ e(C, { animate: o })
    ] })
  ] }) })
] });
export {
  T as FeedCardSkeleton
};
